export enum FormatsEnum {
    Excel = 0,
    PowerPoint = 1,
    ZippedImages = 2,
    Pdf = 3,
    Zip = 4,
    ZipPdf = 5,
    WhatsNewPdf = 6,
}
